import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { ButtonComponent } from '@banyan/modules/standalone/button/button.component';

@Component({
  selector: 'app-plus-minus-button',
  templateUrl: './plus-minus-button.component.html',
  styleUrls: ['./plus-minus-button.component.scss'],
  standalone: true,
  imports: [MatIconModule,
    FormsModule,
    ButtonComponent,
    CommonModule],
})
export class PlusMinusButtonComponent {
  @Input() quantity: number = 0;
  @Input() minQuantity: number = 0;
  @Input() maxQuantity: number | null = null;
  @Input() disabled: boolean = false;
  @Output() quantityEmitEvent = new EventEmitter<number>();

  increase(value: number): number {
    return value + this.minQuantity;
  }

  increaseQuantity(value: number) {
    this.quantity = this.increase(value);
    this.quantityEmitEvent.emit(this.quantity);
  }

  decrease(value: number): number {
    return value - this.minQuantity;
  }

  decreaseQuantity(value: number): void {
    this.quantity = this.decrease(value);
    this.quantityEmitEvent.emit(this.quantity);
  }
}
